import formFieldCommonOptions from 'foundation/js/formFieldCommonOptions'

const options = formFieldCommonOptions('FormCheckbox', {
    validatorFunction(input) {
        return input
    }
})

export default options
